__turbopack_context__.v({
  "product-footer": "r9j_CG_product-footer",
  "product-footer__cta": "r9j_CG_product-footer__cta",
  "product-footer__disclaimer": "r9j_CG_product-footer__disclaimer",
  "product-footer__info": "r9j_CG_product-footer__info",
  "product-footer__rates": "r9j_CG_product-footer__rates",
  "product-footer__rates--expanded": "r9j_CG_product-footer__rates--expanded",
  "product-footer__rates-header": "r9j_CG_product-footer__rates-header",
  "product-rates": "r9j_CG_product-rates",
});
